const WORDS = [
  "Never miss a call",
  "Always book the job",
  "Answered in one ring",
  "24 / 7 / 365",
  "One brain, every channel",
];

export const EditorialMarquee = () => {
  return (
    <section data-testid="editorial-marquee" className="relative py-16 md:py-24 border-y border-white/10 overflow-hidden">
      <div className="flex w-max animate-marquee-slow whitespace-nowrap">
        {[...WORDS, ...WORDS].map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading text-5xl md:text-7xl font-black tracking-tighter text-white/90 px-8">
              {w}
            </span>
            <span className="text-brand text-4xl md:text-6xl px-2">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
